<div class="flex flex-row h-full mic-login">
  <div class="flex flex-col justify-center items-center h-full grow-1 gap-14">
    <div class="flex flex-row justify-center">
      <h1>Machine TK</h1><br>
    </div>
    <form [formGroup]="form" (ngSubmit)="login()" novalidate>
      <div class="flex flex-col w-80 justify-center gap-2">
        <mat-form-field>
          <mat-label>{{ 'app.user.username' | translate }}</mat-label>
          <input formControlName="username" matInput type="text" placeholder="EXXXXXX" required autocomplete="username"
            (input)="toUpperCase($event)" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'app.user.password' | translate }}</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" required autocomplete="current-password"
            formControlName="password" />
          <span mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide" class="hidden-password">
            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </span>
        </mat-form-field>
        <!--<div class="mic-login-password flex flex-row justify-end gap-2">
          <mic-link id="mic-forgot-password" href="/home" label="Forgot password" icon="chevron_right"></mic-link>
        </div>-->
        <div class="mic-login-password flex flex-row justify-end">
          <button mat-flat-button color="primary" class="mic-login-button" type="submit">{{ 'app.general.login' |
            translate }}</button>
        </div>
      </div>
    </form>
    <div class="flex flex-col items-center gap-2 mic-login-footer">
        <div class="flex flex-row items-center gap-4">
          <p>{{ 'app.about.poweredBy' | translate }}</p>
          <mic-logo type="group" link="michelin.fr" ariaLabel="Michelin.fr" target="_blank"></mic-logo>
        </div>

        <span class="mic-version-text flex flex-col items-center leading-tight" style="font-size: 0.6rem; opacity: 0.7;">
          <span>v{{ version }} - {{ releaseDate }}</span>
        </span>
      </div>
  </div>
  <div class="md-hidden"
    [ngClass]="{ 'mic-login-trapeze': !image, 'mic-login-image': image, 'w-4on12': !image, 'w-1on2': image }"></div>
</div>
<mic-alert-center [hideAll]="hideAllAlerts"></mic-alert-center>